import { getIconPath } from "../../../../../config"
import {useEffect, useState} from 'react'

export default function Icon({ icon, style = {}, defaultIcon, isCustomIcon, type, iconPath, metaData }) {
    const [fileUrl, setFileUrl] = useState();
    const [imgSrc, setImgSrc] = useState(null);

    const iconStyle2 = {
        width: 25,
        height: 25,
        filter: 'invert(100%) sepia(0%) saturate(1%) hue-rotate(262deg) brightness(106%) contrast(101%)',
        ...style
    }
    
    const iconStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: 40,
        height: 40,
        transform: 'translate(-50%,-50%)',
    }

    const iconStyleDefault = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: 50,
        height: 50,
        transform: 'translate(-50%,-50%)',      
    }

    useEffect(() => {
        setFileUrl(getIconPath())
    },[])

    useEffect(() => {   
        if(metaData?.iconSource === "library"){
            setImgSrc(`/cached_icons/${icon}`)
        }else if(metaData?.iconSource === "custom" || isCustomIcon){
            setImgSrc(`${fileUrl}${icon}`)
        }else if(!icon && defaultIcon !== undefined){
            setImgSrc(`/${iconPath || 'node_icons'}/${defaultIcon}.svg`)
        }else{
            setImgSrc(`/node_icons/${icon}.svg`)
        }
    },[metaData, fileUrl])

    return (
        <>
            <img style={(icon === undefined || defaultIcon !== undefined) ? iconStyleDefault : iconStyle} src={imgSrc} />
            {/* {icon !== undefined && icon != null && type == 'template' && <img style={{ ...iconStyle, marginLeft: 15 }} src={icon} />}
            {icon !== undefined && icon != null && type !== 'template' && <img style={iconStyle} src={isCustomIcon ? `${fileUrl}${icon}` :`${process.env.PUBLIC_URL}/${iconPath === undefined ? 'node_icons' : iconPath}/${icon}.svg`} />}
            {(icon === undefined || icon == null) && defaultIcon !== undefined && <img style={iconStyleDefault} src={`${process.env.PUBLIC_URL}/${iconPath === undefined ? 'node_icons' : iconPath}/${defaultIcon}.svg`} />} */}
        </>
    )
}